import { List } from '@farol-ds/react'
import { COMPONENT_CLASS, COMPONENT_NAME } from '@jusbrasil-web/shared-ga4-events'
import { sendMetrics } from '@jusbrasil-web/shared-utils-events'
import { formatDate } from '@jusbrasil-web/shared-utils-format'
import { useEffect } from 'react'

import errorImgSrc from '../../../assets/id-document-validation/incompatibility.svg'
import { COMPONENT_RENDER_EVENT_PROPS, GA4EventHandlers } from '../../../hooks'
import { useIdDocumentValidationContext } from '../context'
import { Steps } from '../enums'
import { DocumentStaticStep } from './document-static-step'
import styles from './steps.module.scss'

interface DocumentErrorProps {
  gA4EventHandlers?: GA4EventHandlers
}

export function DocumentError(props: DocumentErrorProps) {
  const { gA4EventHandlers } = props
  const { sharedData, setCurrentStep, eventData, viewer, texts } = useIdDocumentValidationContext()
  const { pid, cpf, birthDate } = viewer || {}
  const { errorType, errorMessage } = sharedData

  useEffect(() => {
    sendMetrics(`UserAccount.IdValidationDocumentErrorViewed`, `${pid}`, {
      ...eventData,
      metadata: {
        ...eventData?.metadata,
        cpf,
        birthDate: birthDate ? formatDate(birthDate) : undefined,
        errorMessage,
        type: errorType,
      },
    })
    gA4EventHandlers?.sendComponentRender({
      componentClass: COMPONENT_CLASS.CPF_VALIDATION_FORM_ATTACHMENT_ACCESS,
      componentName: COMPONENT_NAME.DOCUMENT_VALIDATION,
      renders:
        COMPONENT_RENDER_EVENT_PROPS.VALIDATE_IDENTITY_DOCUMENT_ERROR_CPF_VALIDATION_FORM_ATTACHMENT,
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const title = texts?.documentError?.title ?? 'Documento não identificado'
  const retryLabel = texts?.documentError?.retryButtonText ?? 'Tentar Novamente'

  const onRetry = () => {
    sendMetrics('UserAccount.IdValidationDocumentErrorRetry', `${pid}`, { ...eventData })
    setCurrentStep(Steps.VALIDATE_DOCUMENT)
  }

  return (
    <DocumentStaticStep
      testId="document-error-step"
      imageSrc={errorImgSrc}
      title={title}
      bodyText="Não foi possível validar o documento, as possíveis razões para isso acontecer são:"
      bodyText2={
        <List unstyled={false} className={styles.reasonsList}>
          <List.Item>O documento não ficou legível (foto escura ou tremida)</List.Item>
          <List.Item>O CPF não aparece no documento</List.Item>
          <List.Item>O documento não pertence a você</List.Item>
        </List>
      }
      action={{
        label: retryLabel,
        onClick: onRetry,
      }}
    />
  )
}
